import { useQueryClient } from '@tanstack/react-query'
import { useWallet } from '@txnlab/use-wallet-react'
import dayjs from 'dayjs'
import { usePostSale } from 'api/hooks/usePostSale'
import useErrorToast from 'hooks/useErrorToast'
// import useRelativeTime from 'hooks/useRelativeTime'
import { useOfferStore } from 'store/state/offerStore'
import type { NFDAnalyticRecord } from 'api/api-client'
import type { OffersType } from './InfiniteOffers.types'

export default function useInfiniteOffers() {
  const queryClient = useQueryClient()

  // useRelativeTime({
  //   s: 'just now',
  //   m: 'a minute ago',
  //   mm: '%dm ago',
  //   h: '1h ago',
  //   hh: '%dh ago',
  //   d: '1d ago',
  //   dd: '%dd ago',
  //   M: '1mo ago',
  //   MM: '%dmo ago',
  //   y: '1y ago',
  //   yy: '%dy ago'
  // })

  const offersType = useOfferStore((state) => state.offersType)
  const setOffersType = useOfferStore((state) => state.setOffersType)

  const setLastViewedReceived = useOfferStore((state) => state.setLastViewedReceived)
  const setLastViewedSent = useOfferStore((state) => state.setLastViewedSent)

  const { activeAccount } = useWallet()

  const handleError = useErrorToast()

  const { mutateAsync: acceptOffer } = usePostSale({
    onSuccess: (data, params) => {
      queryClient.invalidateQueries({ queryKey: ['name', params.name] })
      queryClient.invalidateQueries({ queryKey: ['analytics'] })
    },
    toasts: {
      success: 'Offer accepted!'
    }
  })

  const handleOffersTypeChange = (type: OffersType) => {
    setOffersType(type)
  }

  const handleClickMarkAsRead = () => {
    offersType === 'received'
      ? setLastViewedReceived(activeAccount?.address, dayjs().toISOString())
      : setLastViewedSent(activeAccount?.address, dayjs().toISOString())
  }

  const handleClickAcceptOffer = async (offer: NFDAnalyticRecord) => {
    try {
      await acceptOffer({
        name: offer.data?.name as string,
        body: {
          reservedFor: offer.data?.buyer as string,
          offer: offer.price as number,
          sender: offer.data?.seller as string
        }
      })
    } catch (e) {
      handleError(e)
    }
  }

  return {
    offersType,
    handleOffersTypeChange,
    handleClickMarkAsRead,
    handleClickAcceptOffer
  }
}
